import { Button, Typography } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';

import { ReactComponent as RabbitLogo } from 'assets/SVGs/logo.svg';
import { ConsentBanner } from 'components/ConsentBanner';
import { settings } from 'config';

import { Background } from '../styledComponents';
import {
  AuthText,
  AuthContentWrapper,
  AuthLogoWrapper,
  AuthComponents,
  AuthComponentWrapper,
} from './styledComponents';

export const Authentication: React.FC = () => {
  const { oktaAuth } = useOktaAuth();
  const login = () =>
    oktaAuth.signInWithRedirect({
      originalUri: settings.APP_ORIGINAL_URI + '/home',
    });

  return (
    <>
      <ConsentBanner />
      <Background>
        <AuthLogoWrapper>
          <RabbitLogo />
          <Typography
            variant='h4'
            noWrap
            component='div'
            align='center'
            sx={{
              mr: 2,
              ml: 2,
              letterSpacing: '.2em',
              display: { md: 'flex' },
              color: 'white',
              alignItems: 'center',
            }}
          >
            RABBIT
          </Typography>
        </AuthLogoWrapper>
        <AuthContentWrapper>
          <AuthComponents>
            <AuthComponentWrapper sx={{ alignItems: 'flex-end' }}>
              <AuthText>
                <h5>Welcome to Rabbit</h5>
                <p>
                  Rabbit helps employers to verify employment of people who
                  worked for the DOD in support of Operation Enduring Freedom.
                </p>
              </AuthText>
              <AuthComponentWrapper sx={{ alignItems: 'flex-end' }}>
                <AuthText>
                  <Typography>
                    Click the login button to authenticate
                  </Typography>
                  <Button variant='contained' onClick={login}>
                    Login
                  </Button>
                </AuthText>
              </AuthComponentWrapper>
            </AuthComponentWrapper>
          </AuthComponents>
        </AuthContentWrapper>
      </Background>
    </>
  );
};
